import { api } from "./auth";

// TODO-PROD: Rotate FONNTE_TOKEN via backend env only; never expose to frontend.
// Current integration is proxied through POST /api/wa/send so the token lives in backend/.env.

export async function kirimWA({ target, message, caseId = null, jenis = null }) {
  try {
    const { data } = await api.post("/wa/send", {
      target,
      message,
      case_id: caseId,
      jenis,
    });
    return {
      ok: !!data.ok,
      normalizedTarget: data.normalized_target,
      httpStatus: data.http_status,
      providerData: data.data,
      error: data.ok ? null : data.error || "Pesan gagal dikirim",
    };
  } catch (err) {
    return {
      ok: false,
      error: err?.response?.data?.detail || err.message || "Network error",
    };
  }
}

export function normalizeWANumberLocal(raw) {
  const s = String(raw || "").replace(/\D/g, "");
  if (!s) return "";
  if (s.startsWith("62")) return s;
  if (s.startsWith("0")) return "62" + s.slice(1);
  if (s.startsWith("8")) return "62" + s;
  return s;
}
